import type { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import DataTableOrgExtensionsTab from '@/pages/dashboard/tabs/DataTableOrgExtensionsTab';

/**
 * Extensions tab for the organization view.
 * Delegates to DataTableOrgExtensionsTab which provides filtering,
 * sorting, search, and pagination via the DataTable component.
 */
export default function ExtensionsTab(): ReactElement | null {
  const { organizationId } = useParams<{ organizationId: string }>();

  if (!organizationId) {
    return null;
  }

  return <DataTableOrgExtensionsTab organizationId={organizationId} />;
}
